import { render, staticRenderFns } from "./TestimonyPhone.vue?vue&type=template&id=8e0af0b2&"
import script from "./TestimonyPhone.vue?vue&type=script&lang=js&"
export * from "./TestimonyPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports